import { Users } from "@/lib/users/types";
import { User } from "lucide-react";
import Image from "next/image";
import { useState } from "react";

export const ImpersonateUserRow = ({
  user,
  handleImpersonate,
}: {
  user: Users;
  handleImpersonate: (user: Users) => void;
}) => {
  const [imageError, setImageError] = useState(false);

  return (
    <button
      key={user.user_id}
      onClick={() => handleImpersonate(user)}
      className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors border border-gray-200 text-left"
    >
      <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0 overflow-hidden">
        {user.profile_picture_url && user.profile_picture_url.startsWith("http") && !imageError ? (
          <Image
            src={user.profile_picture_url}
            alt={user.full_name ?? `${user.first_name} ${user.last_name}`}
            width={40}
            height={40}
            className="rounded-full object-cover"
            loading="lazy"
            quality={65}
            sizes="40px"
            onError={() => setImageError(true)}
          />
        ) : (
          <User className="w-5 h-5 text-indigo-600" />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-900 truncate">
          {user.full_name ?? user.first_name + " " + user.last_name}
        </p>
        <p className="text-xs font-medium text-gray-500 truncate">{user.email}</p>
      </div>
    </button>
  );
};
